import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
    studentView: {
        id: 'NavigationDropdown.studentView',
        description: 'Link to student view',
        defaultMessage: 'Student view',
    },
    externalLabel: {
        id: 'NavigationDropdown.externalLabel',
        description: 'Aria text for external icon',
        defaultMessage: '(opens in new tab)',
    },
    editButtonText: {
        id: 'classMenu.editButtonText',
        defaultMessage: 'Edit',
    },
    editButtonLabel: {
        id: 'classMenu.editButtonLabel',
        defaultMessage: 'Edit class details',
    },
    dayOf: {
        id: 'NavigationDropdown.dayOf',
        description: 'Link to day-of page',
        defaultMessage: 'Class day-of',
    },
    classDetails: {
        id: 'NavigationDropdown.classDetails',
        description: 'Link to class details page',
        defaultMessage: 'Class details',
    },
    manageLabs: {
        id: 'NavigationDropdown.manageLabs',
        description: 'Link to manage labs page',
        defaultMessage: 'Manage labs',
    },
    classAttendanceButtonText: {
        id: 'classMenu.classAttendanceButtonText',
        defaultMessage: 'Attendance',
    },
    classAttendanceButtonLabel: {
        id: 'classMenu.classAttendanceButtonLabel',
        defaultMessage: 'View and report class attendance',
    },
    classHasNoLabsReason: {
        id: 'NavigationDropdown.classHasNoLabsReason',
        defaultMessage: 'The class has no labs',
    },
    classNotes: {
        id: 'NavigationDropdown.classNotes',
        defaultMessage: 'Notes',
    },
});
